// The last signed-in uid, in memory only: a reload forgets it, so a reload keeps a person's tabs,
// while a different person in the same page never inherits them.
let lastUid: string | null = null;
let pendingFor: string | null = null;

export function noteSessionUser(uid: string | null): void {
  // A sign-out keeps the last uid: the next person is compared against whoever was here before.
  if (uid === null) return;
  if (lastUid !== null && lastUid !== uid) pendingFor = uid;
  lastUid = uid;
}

export function isTabHandoffPending(uid: string): boolean {
  return pendingFor === uid;
}

export function completeTabHandoff(uid: string): void {
  if (pendingFor === uid) pendingFor = null;
}

export function withoutParam(search: string, param: string): string {
  const params = new URLSearchParams(search);
  params.delete(param);
  const rest = params.toString();
  return rest === '' ? '' : `?${rest}`;
}

// Module state outlives a test case.
export function resetTabHandoff(): void {
  lastUid = null;
  pendingFor = null;
}
